import Vue from "vue";
import VueRouter from "vue-router";
import WriteNewPassword from "../views/AuthPages/Default/writeNewPassword.vue";
import { getAccessToken, isAuthenticated, resetAccessToken } from "../Utils/authentication";
import store from "../store";
/* Layouts */
const Layout1 = () => import("../layouts/Layout1.vue");
const Layout2 = () => import("../layouts/Layout2.vue");
const Layout3 = () => import("../layouts/Layout3.vue");
const Layout4 = () => import("../layouts/Layout4.vue");
const Layout5 = () => import("../layouts/Layout5.vue");
const Layout6 = () => import("../layouts/Layout6.vue");
const Default = () => import("../layouts/BlankLayout");
const AuthLayout = () => import("../layouts/AuthLayouts/AuthLayout");
const MenusList = () => import("../views/Pages/Menus/List.vue");
const BranchesList = () => import("../views/Pages/Branches/List.vue");
const FloorsList = () => import("../views/Pages/Floors/List.vue");
const TablesList = () => import("../views/Pages/Floors/Tables/List.vue");
const BusinessList = () => import("../views/Pages/Business/List.vue");
const ServicesList = () => import("../views/Pages/Services/List.vue");
const HolidaysList = () => import("../views/Pages/Holidays/List.vue");
const CategoriesList = () => import("../views/Pages/Categories/List.vue");
const InvoicesList = () => import("../views/Pages/Invoices/List.vue");
const OrdersList = () => import("../views/Pages/Orders/List.vue");
const ReservationsList = () => import("../views/Pages/Reservations/List.vue");
const UsersList = () => import("../views/Pages/Users/List.vue");
const SettingsList = () => import("../views/Pages/Settings/List.vue");
const PermissionsList = () => import ("../views/Pages/Permissions/List.vue")
/* Dashboards View */
const Dashboard1 = () => import("../views/Dashboards/Dashboard1.vue");
const Dashboard2 = () => import("../views/Dashboards/Dashboard2.vue");
const Dashboard3 = () => import("../views/Dashboards/Dashboard3");
const Dashboard4 = () => import("../views/Dashboards/Dashboard4");
const Dashboard5 = () => import("../views/Dashboards/Dashboard5");
const Dashboard6 = () => import("../views/Dashboards/Dashboard6");
/* UIElements View */
const UiAlerts = () => import("../views/core/UiAlerts.vue");
const UiButtons = () => import("../views/core/UiButtons.vue");
const UiBadges = () => import("../views/core/UiBadges.vue");
const UiBreadcrumb = () => import("../views/core/UiBreadcrumb.vue");
const UiColors = () => import("../views/core/UiColors.vue");
const UiTypography = () => import("../views/core/UiTypography.vue");
const UiCards = () => import("../views/core/UiCards.vue");
const UiCarousel = () => import("../views/core/UiCarousel.vue");
const UiEmbedVideo = () => import("../views/core/UiEmbedVideo.vue");
const UiGrid = () => import("../views/core/UiGrid.vue");
const UiModal = () => import("../views/core/UiModal.vue");
const UiListGroup = () => import("../views/core/UiListGroup.vue");
const UiImages = () => import("../views/core/UiImages.vue");
const UiMediaObject = () => import("../views/core/UiMediaObject.vue");
const UiTooltips = () => import("../views/core/UiTooltips.vue");
const UiPopovers = () => import("../views/core/UiPopovers.vue");
const UiNotifications = () => import("../views/core/UiNotifications.vue");
const UiTabs = () => import("../views/core/UiTabs.vue");
const UiPagination = () => import("../views/core/UiPagination.vue");
const UiProgressBars = () => import("../views/core/UiProgressBars.vue");
/* Authentic View */
const SignIn1 = () => import("../views/AuthPages/Default/SignIn1");
const SignUp1 = () => import("../views/AuthPages/Default/SignUp1");
const RecoverPassword1 = () =>
  import("../views/AuthPages/Default/RecoverPassword1");
const LockScreen1 = () => import("../views/AuthPages/Default/LockScreen1");
const ConfirmMail1 = () => import("../views/AuthPages/Default/ConfirmMail1");
const Callback = () => import("../views/AuthPages/Default/Callback");
/* Extra Pages */
const ErrorPage = () => import("../views/Pages/ErrorPage");
const ComingSoon = () => import("../views/Pages/ComingSoon");
const Maintenance = () => import("../views/Pages/Maintenance");
const TimeLine = () => import("../views/Pages/TimeLines");
const Pricing = () => import("../views/Pages/Pricing");
const Pricing1 = () => import("../views/Pages/Pricing1");
const BlankPage = () => import("../views/Pages/BlankPage");
const FAQ = () => import("../views/Pages/FAQ");
const Invoice = () => import("../views/Pages/Invoice");
/* Apps Views */
const EmailListing = () => import("../views/Apps/Email/EmailListing");
const EmailCompose = () => import("../views/Apps/Email/EmailCompose");
const Calendar = () => import("../views/Apps/Calendar/Calendar");
const ECommerceListing = () => import("../views/Apps/Ecommerce/Listing");
const Checkout = () => import("../views/Apps/Ecommerce/Checkout");
const Wishlist = () => import("../views/Apps/Ecommerce/Wishlist");
const EcommerceDetail = () => import("../views/Apps/Ecommerce/Detail");
const ChatIndex = () => import("../views/Apps/Chat/Index");
const ProjectBoard = () =>
  import("../views/Apps/ProjectManagement/ProjectBoard");
/* Icon Views */
const IconDripicons = () => import("../views/Icons/IconDripicons");
const IconFontawesome5 = () => import("../views/Icons/IconFontawesome5");
const IconLineAwesome = () => import("../views/Icons/IconLineAwesome");
const IconRemixicon = () => import("../views/Icons/IconRemixicon");
const IconUnicons = () => import("../views/Icons/IconUnicons");
/* Tables Views */
const TablesBasic = () => import("../views/Tables/TablesBasic");
const EditableTable = () => import("../views/Tables/EditableTable");
/* Charts View */
const ApexCharts = () =>
  import(
    /* webpackPrefetch: true */ /* webpackChunkName: "ApexChart" */ "../views/Charts/ApexCharts"
  );
const AmCharts = () =>
  import(
    /* webpackPrefetch: true */ /* webpackChunkName: "AmCharts" */ "../views/Charts/AmCharts"
  );
const HighCharts = () =>
  import(
    /* webpackPrefetch: true */ /* webpackChunkName: "HighCharts" */ "../views/Charts/HighCharts"
  );
/* Google Map */
const GoogleMaps = () => import("../views/Maps/GoogleMaps");
/* Form View */
const FormLayout = () => import("../views/Forms/FormLayout");
const FormValidates = () => import("../views/Forms/FormValidates");
const FormSwitches = () => import("../views/Forms/FormSwitches");
const FormRadios = () => import("../views/Forms/FormRadios");
const FormCheckboxes = () => import("../views/Forms/FormCheckboxes");
/* User View */
const Profile = () => import("../views/User/Profile");
const ProfileEdit = () => import("../views/User/ProfileEdit");
const AddUser = () => import("../views/User/AddUser");
const UserList = () => import("../views/User/UserList");
const AccountSetting = () => import("../views/User/AccountSetting");
const PrivacySetting = () => import("../views/User/PrivacySetting");
/* Apps View */
const SocialApp = () => import("../views/Apps/Social/SocialApp");
const TodoListing = () => import("../views/Apps/Todo/TodoListing");
/* Plugins Views */
const DatepickerDemo = () => import("../views/Plugins/DatepickerDemo");
const SelectDemo = () => import("../views/Plugins/SelectDemo");
const DragDropDemo = () => import("../views/Plugins/DragDropDemo");
const AppTreeView = () => import("../views/Plugins/AppTreeView");

Vue.use(VueRouter);
const mainPages = prop => [
  {
    path: "menus",
    name: prop + ".menus",
    meta: { auth: true, name: "menus" },
    component: MenusList
  },
  {
    path: "branches",
    name: prop + ".branches",
    meta: { auth: true, name: "branches" },
    component: BranchesList
  },
  {
    path: "business",
    name: prop + ".business",
    meta: { auth: true, name: "business" },
    component: BusinessList
  },
  {
    path: "services",
    name: prop + ".services",
    meta: { auth: true, name: "services" },
    component: ServicesList
  },
  {
    path: "holidays",
    name: prop + ".holidays",
    meta: { auth: true, name: "holidays" },
    component: HolidaysList
  },
  {
    path: "categories",
    name: prop + ".categories",
    meta: { auth: true, name: "categories" },
    component: CategoriesList
  },
  {
    path: "orders",
    name: prop + ".orders",
    meta: { auth: true, name: "orders" },
    component: OrdersList
  },
  {
    path: "reservations",
    name: prop + ".reservations",
    meta: { auth: true, name: "reservations" },
    component: ReservationsList
  },
  {
    path: "invoices",
    name: prop + ".invoices",
    meta: { auth: true, name: "invoices" },
    component: InvoicesList
  },
  {
    path: "users",
    name: prop + ".users",
    meta: { auth: true, name: "users" },
    component: UsersList
  },
  {
    path: "settings",
    name: prop + ".settings",
    meta: { auth: true, name: "settings" },
    component: SettingsList
  },
  {
    path: "permissions",
    name: prop + ".permissions",
    meta: { auth: true, name: "permissions" },
    component: PermissionsList
  },
  {
    path: "floors",
    name: prop + ".floors",
    meta: { auth: true, name: "floors" },
    component: FloorsList
  },
  {
    path: "floors/:floorId/tables",
    name: prop + ".floors.tables",
    meta: { auth: true, name: "Tables" },
    component: TablesList,
    props: route => ({
      floorId: route.params.floorId,
      selectedBusinessId: route.query.rid,
      selectedBranchId: route.query.bid
    })
  }
];
const coreChildRoute = prop => [
  {
    path: "ui-colors",
    name: prop + ".color",
    meta: { auth: true, name: "Colors" },
    component: UiColors
  },
  {
    path: "ui-typography",
    name: prop + ".typography",
    meta: { auth: true, name: "Typography" },
    component: UiTypography
  },
  {
    path: "ui-alerts",
    name: prop + ".alert",
    meta: { auth: true, name: "Alert" },
    component: UiAlerts
  },
  {
    path: "ui-buttons",
    name: prop + ".button",
    meta: { auth: true, name: "Button" },
    component: UiButtons
  },
  {
    path: "ui-breadcrumb",
    name: prop + ".breadcrumb",
    meta: { auth: true, name: "Breadcrumb" },
    component: UiBreadcrumb
  },
  {
    path: "ui-badges",
    name: prop + ".badges",
    meta: { auth: true, name: "Badges" },
    component: UiBadges
  },
  {
    path: "ui-cards",
    name: prop + ".cards",
    meta: { auth: true, name: "Card" },
    component: UiCards
  },
  {
    path: "ui-carousel",
    name: prop + ".carousel",
    meta: { auth: true, name: "Carousel" },
    component: UiCarousel
  },
  {
    path: "ui-grid",
    name: prop + ".grid",
    meta: { auth: true, name: "Grid" },
    component: UiGrid
  },
  {
    path: "ui-embed-video",
    name: prop + ".embed-video",
    meta: { auth: true, name: "Embed Video" },
    component: UiEmbedVideo
  },
  {
    path: "ui-modal",
    name: prop + ".modal",
    meta: { auth: true, name: "Model" },
    component: UiModal
  },
  {
    path: "ui-listgroup",
    name: prop + ".listgroup",
    meta: { auth: true, name: "List Group" },
    component: UiListGroup
  },
  {
    path: "ui-images",
    name: prop + ".images",
    meta: { auth: true, name: "Image" },
    component: UiImages
  },
  {
    path: "ui-media-object",
    name: prop + ".media-object",
    meta: { auth: true, name: "Media Object" },
    component: UiMediaObject
  },
  {
    path: "ui-pagination",
    name: prop + ".pagination",
    meta: { auth: true, name: "Paginations" },
    component: UiPagination
  },
  {
    path: "ui-progressbars",
    name: prop + ".progressbars",
    meta: { auth: true, name: "Progressbar" },
    component: UiProgressBars
  },
  {
    path: "ui-tooltips",
    name: prop + ".tooltips",
    meta: { auth: true, name: "Tooltip" },
    component: UiTooltips
  },
  {
    path: "ui-popovers",
    name: prop + ".popovers",
    meta: { auth: true, name: "Popover" },
    component: UiPopovers
  },
  {
    path: "ui-notifications",
    name: prop + ".notifications",
    meta: { auth: true, name: "Notification" },
    component: UiNotifications
  },
  {
    path: "ui-tabs",
    name: prop + ".tabs",
    meta: { auth: true, name: "Tabs" },
    component: UiTabs
  }
];
const formChildRoute = prop => [
  {
    path: "form-layout",
    name: prop + ".layout",
    meta: { auth: true, name: "Layout" },
    component: FormLayout
  },
  {
    path: "form-validate",
    name: prop + ".validate",
    meta: { auth: true, name: "Validate" },
    component: FormValidates
  },
  {
    path: "form-switches",
    name: prop + ".switch",
    meta: { auth: true, name: "Switch" },
    component: FormSwitches
  },
  {
    path: "form-radios",
    name: prop + ".radio",
    meta: { auth: true, name: "Radio" },
    component: FormRadios
  },
  {
    path: "form-checkboxes",
    name: prop + ".checkbox",
    meta: { auth: true, name: "Checkbox" },
    component: FormCheckboxes
  }
];

const tableChildRoute = prop => [
  {
    path: "tables-basic",
    name: prop + ".basic",
    meta: { auth: true, name: "Basic" },
    component: TablesBasic
  },
  {
    path: "editable",
    name: prop + ".editable",
    meta: { auth: true, name: "Editable" },
    component: EditableTable
  }
];

const iconChildRoute = prop => [
  {
    path: "dripicons",
    name: prop + ".dripicons",
    meta: { auth: true, name: "Dripicons" },
    component: IconDripicons
  },
  {
    path: "fontawesome-5",
    name: prop + ".fontawesome-5",
    meta: { auth: true, name: "Font Awsome" },
    component: IconFontawesome5
  },
  {
    path: "lineawesome",
    name: prop + ".lineawesome",
    meta: { auth: true, name: "Line Awsome" },
    component: IconLineAwesome
  },
  {
    path: "remixicon",
    name: prop + ".remixicon",
    meta: { auth: true, name: "Remixicon" },
    component: IconRemixicon
  },
  {
    path: "unicons",
    name: prop + ".unicons",
    meta: { auth: true, name: "Unicon" },
    component: IconUnicons
  }
];

const chartChildRoutes = prop => [
  {
    path: "apex-charts",
    name: prop + ".apex",
    meta: { auth: true, name: "Apex Chart" },
    component: ApexCharts
  },
  {
    path: "am-charts",
    name: prop + ".am",
    meta: { auth: true, name: "Am Chart" },
    component: AmCharts
  },
  {
    path: "high-charts",
    name: prop + ".high",
    meta: { auth: true, name: "High Chart" },
    component: HighCharts
  }
];

const appChildRoute = prop => [
  {
    path: "calendar",
    name: prop + ".calendar",
    meta: { auth: true, name: "Calendar" },
    component: Calendar
  },
  {
    path: "chat",
    name: prop + ".chat",
    meta: { auth: true, name: "Chat" },
    component: ChatIndex
  },
  {
    path: "email",
    name: prop + ".email",
    meta: { auth: true, name: "Email" },
    component: EmailListing
  },
  {
    path: "email-compose",
    name: prop + ".email.compose",
    meta: { auth: true, name: "New Email" },
    component: EmailCompose
  },
  {
    path: "e-commerce/listing",
    name: prop + ".e-commerce.index",
    meta: { auth: true, name: "Product list" },
    component: ECommerceListing
  },
  {
    path: "e-commerce/detail",
    name: prop + ".e-commerce.detail",
    meta: { auth: true, name: "Product Detail" },
    component: EcommerceDetail
  },
  {
    path: "e-commerce/checkout",
    name: prop + ".e-commerce.cart",
    meta: { auth: true, name: "Checkout" },
    component: Checkout
  },
  {
    path: "e-commerce/wish-list",
    name: prop + ".e-commerce.wishlist",
    meta: { auth: true, name: "Wishlist" },
    component: Wishlist
  },
  {
    path: "project-management",
    name: prop + ".project.management",
    meta: { auth: true, name: "Project Management" },
    component: ProjectBoard
  },
  {
    path: "todo",
    name: prop + ".todo",
    meta: { auth: true, name: "Todo" },
    component: TodoListing
  },
  {
    path: "treeview",
    name: prop + ".treeview",
    meta: { auth: true, name: "Tree View" },
    component: AppTreeView
  }
];

const authChildRoutes = prop => [
  {
    path: "sign-in1",
    name: prop + ".sign-in1",
    meta: { auth: true },
    component: SignIn1
  },
  {
    path: "sign-up1",
    name: prop + ".sign-up1",
    meta: { auth: true },
    component: SignUp1
  },
  {
    path: "password-reset1",
    name: prop + ".password-reset1",
    meta: { auth: false },
    component: RecoverPassword1
  },
  {
    path: "lock-screen1",
    name: prop + ".lock-screen1",
    meta: { auth: true },
    component: LockScreen1
  },
  {
    path: "confirm-mail1",
    name: prop + ".confirm-mail1",
    meta: { auth: false },
    component: ConfirmMail1
  },
  {
    path: "write-new-password",
    name: prop + ".write-new-password",
    meta: { auth: false },
    component: WriteNewPassword
  }
];

const mapChildRoute = prop => [
  {
    path: "google-maps",
    name: prop + ".google",
    meta: { auth: true, name: "Google map" },
    component: GoogleMaps
  }
];

const defaultlayout = prop => [
  {
    path: "timeline",
    name: prop + ".timeline",
    meta: { auth: true, name: "Timeline" },
    component: TimeLine
  },
  {
    path: "invoice",
    name: prop + ".invoice",
    meta: { auth: true, name: "Invoice" },
    component: Invoice
  },
  {
    path: "blank-page",
    name: prop + ".blank-page",
    meta: { auth: true, name: "Blank Page" },
    component: BlankPage
  },
  {
    path: "pricing",
    name: prop + ".pricing",
    meta: { auth: true, name: "Pricing" },
    component: Pricing
  },
  {
    path: "pricing-1",
    name: prop + ".pricing1",
    meta: { auth: true, name: "Pricing 1" },
    component: Pricing1
  },
  {
    path: "faq",
    name: prop + ".faq",
    meta: { auth: true, name: "Faq" },
    component: FAQ
  }
];

const pagesChildRoutes = prop => [
  {
    path: "error/:code",
    name: prop + ".error",
    meta: { auth: true },
    component: ErrorPage
  },
  {
    path: "coming-soon",
    name: prop + ".coming-soon",
    meta: { auth: true },
    component: ComingSoon
  },
  {
    path: "maintenance",
    name: prop + ".maintenance",
    meta: { auth: true },
    component: Maintenance
  }
];
const userChildRoute = prop => [
  {
    path: "profile",
    name: prop + ".profile",
    meta: { auth: true, name: "Profile" },
    component: Profile
  },
  {
    path: "profile-edit/:id",
    name: prop + ".edit",
    meta: { auth: true, name: "Edit Profile" },
    component: ProfileEdit
  },
  {
    path: "add-user",
    name: prop + ".add",
    meta: { auth: true, name: "Add Profile" },
    component: AddUser
  },
  {
    path: "user-list",
    name: prop + ".list",
    meta: { auth: true, name: "User List" },
    component: UserList
  },
  {
    path: "account-setting",
    name: prop + ".account-setting",
    meta: { auth: true, name: "Account Setting" },
    component: AccountSetting
  },
  {
    path: "privacy-setting",
    name: prop + ".privacy-setting",
    meta: { auth: true, name: "Privacy Setting" },
    component: PrivacySetting
  }
];
const socialChildRoute = prop => [
  {
    path: "social",
    name: prop + ".list",
    meta: { auth: true, name: "Social App" },
    component: SocialApp
  }
];

const pluginsChildRoute = prop => [
  {
    path: "datepicker",
    name: prop + ".datepicker",
    meta: { auth: true, name: "Datepicker" },
    component: DatepickerDemo
  },
  {
    path: "select",
    name: prop + ".select",
    meta: { auth: true, name: "Select" },
    component: SelectDemo
  },
  {
    path: "draggable",
    name: prop + ".draggable",
    meta: { auth: true, name: "Draggable" },
    component: DragDropDemo
  }
];
const routes = [
  {
    path: "/",
    name: "dashboard",
    component: Layout1,
    meta: { auth: true },
    children: [
      {
        path: "",
        name: "dashboard.home-1",
        meta: { auth: true, name: "Home 1" },
        component: Dashboard1
      }
    ]
  },
  {
    path: "",
    name: "dashboard",
    component: Layout2,
    meta: { auth: true },
    children: [
      {
        path: "home-2",
        name: "dashboard.home-2",
        meta: { auth: true, name: "Home 2" },
        component: Dashboard2
      }
    ]
  },
  {
    path: "/menu-design",
    name: "dashboard",
    component: Layout3,
    meta: { auth: true },
    children: [
      {
        path: "home-3",
        name: "dashboard.home-3",
        meta: { auth: true, name: "Home 3" },
        component: Dashboard3
      }
    ]
  },
  {
    path: "/menu-design",
    name: "dashboard",
    component: Layout4,
    meta: { auth: true },
    children: [
      {
        path: "home-4",
        name: "dashboard.home-4",
        meta: { auth: true, name: "Home 4" },
        component: Dashboard4
      }
    ]
  },
  {
    path: "",
    name: "dashboard",
    component: Layout5,
    meta: { auth: true },
    children: [
      {
        path: "home-5",
        name: "dashboard.home-5",
        meta: { auth: true, name: "Home 5" },
        component: Dashboard5
      }
    ]
  },
  {
    path: "",
    name: "dashboard",
    component: Layout6,
    meta: { auth: true },
    children: [
      {
        path: "home-6",
        name: "dashboard.home-6",
        meta: { auth: true, name: "Home 6" },
        component: Dashboard6
      }
    ]
  },
  {
    path: "/core",
    name: "core",
    component: Layout2,
    meta: { auth: true },
    children: coreChildRoute("core")
  },
  {
    path: "",
    name: "main-pages",
    component: Layout2,
    meta: { auth: true },
    children: mainPages("main-pages")
  },

  {
    path: "/table",
    name: "table",
    component: Layout2,
    meta: { auth: true },
    children: tableChildRoute("table")
  },
  {
    path: "/chart",
    name: "chart",
    component: Layout2,
    meta: { auth: true },
    children: chartChildRoutes("chart")
  },
  {
    path: "/icon",
    name: "icon",
    component: Layout2,
    meta: { auth: true },
    children: iconChildRoute("icon")
  },
  {
    path: "/auth",
    name: "auth1",
    component: AuthLayout,
    meta: { auth: true },
    children: authChildRoutes("auth1")
  },
  {
    path: "/pages",
    name: "pages",
    component: Default,
    meta: { auth: true },
    children: pagesChildRoutes("default")
  },
  {
    path: "/extra-pages",
    name: "extra-pages",
    component: Layout2,
    meta: { auth: true },
    children: defaultlayout("extra-pages")
  },

  {
    path: "/app",
    name: "app",
    component: Layout2,
    meta: { auth: true },
    children: appChildRoute("app")
  },
  {
    path: "/user",
    name: "user",
    component: Layout2,
    meta: { auth: true },
    children: userChildRoute("user")
  },
  {
    path: "/social",
    name: "social",
    component: Layout2,
    meta: { auth: true },
    children: socialChildRoute("social")
  },
  {
    path: "/map",
    name: "map",
    component: Layout2,
    meta: { auth: true },
    children: mapChildRoute("map")
  },
  {
    path: "/form",
    name: "form",
    component: Layout2,
    meta: { auth: true },
    children: formChildRoute("form")
  },
  {
    path: "/plugins",
    name: "plugins",
    component: Layout2,
    meta: { auth: true },
    children: pluginsChildRoute("plugins")
  },
  {
    path: "/callback",
    name: "callback",
    meta: { auth: false },
    component: Callback
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.VUE_APP_BASE_URL,
  routes
});

router.beforeEach(async (to, from, next) => {
  const publicPages = ["/auth/sign-in1", "/auth/sign-up1", "/dark/auth/sign-in1", "/dark/auth/sign-up1"];
  const isPublicPage = publicPages.includes(to.path);
  const authRequired = !isPublicPage;
  // Always check authentication status
  const isAuthenticatedUser = getAccessToken() ? await isAuthenticated(store) : false;
  // If the user is authenticated and tries to access a public page, redirect to dashboard
  if (isPublicPage && isAuthenticatedUser) {
    return next({ name: "dashboard.home-1" });
  }
  // If it's a public page and the user is not authenticated, execute resetAccessToken
  if (isPublicPage && !isAuthenticatedUser) {
    resetAccessToken();
  }
  // If the page requires authentication and the user is not authenticated, redirect to login
  if (authRequired && !isAuthenticatedUser) {
    return next("/auth/sign-in1");
  }
  // Permissions logic
  const rawPermissions = store.state.userPermissions?.permissions || [];
  const userPermissions = rawPermissions
    .map(p => {
      const match = p.match(/([^.]+\.[^.]+)$/);
      return match ? match[1] : null;
    })
    .filter(Boolean);

  const metaName = to.meta.name;
  const requiredPermission = metaName ? `${metaName}.read` : null;
  const isHome1 = to.name === "dashboard.home-1";

  if (!isHome1 && requiredPermission && !userPermissions.includes(requiredPermission)) {
    return next({ name: "dashboard.home-1" });
  }

  return next();
});

export default router;
